import script from "./CreateResidentDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateResidentDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./create-resident-drawer.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__